/**
 * Centralised API configuration from environment variables.
 * All services should import from here instead of reading env vars directly.
 */

/** REST API base URL (no trailing slash) */
export const API_BASE_URL = import.meta.env.VITE_API_URL as string || '';

/** REST API key for x-api-key header */
export const API_KEY = import.meta.env.VITE_API_KEY as string || '';

/** WebSocket API endpoint URL */
export const WS_URL = import.meta.env.VITE_WS_URL as string || '';
